import { useQuery } from '@tanstack/react-query';
import { fetchPhaseDurations, FALLBACK_PHASES, type PhaseDurations } from './api';

/**
 * Faz sureleri (GET /v1/config) — TEK sorgu anahtari.
 *
 * "Nasil calisir?" paneli ve musteri kartindaki uyari penceresi ayni degerleri okuyor; iki
 * ayri anahtar ayni sabitleri iki kez cekerdi. Uc erisilemezse istemci varsayilanlariyla
 * devam eder (bkz. api.ts FALLBACK_PHASES) — bir sure sabiti icin ekrani bloke etmek orantisiz.
 */
export const PHASE_DURATIONS_QUERY_KEY = ['config', 'phases'] as const;

export const usePhaseDurations = (enabled = true): PhaseDurations => {
  const query = useQuery({
    queryKey: PHASE_DURATIONS_QUERY_KEY,
    queryFn: fetchPhaseDurations,
    // Sabit sayilar; her acilista yeniden cekmek gereksiz.
    staleTime: 60 * 60 * 1000,
    enabled,
  });
  return query.data ?? FALLBACK_PHASES;
};
